import { render, staticRenderFns } from "./ChannelSubscriberSubscribe.vue?vue&type=template&id=355a6a12&scoped=true"
import script from "./ChannelSubscriberSubscribe.vue?vue&type=script&lang=ts"
export * from "./ChannelSubscriberSubscribe.vue?vue&type=script&lang=ts"
import style0 from "./ChannelSubscriberSubscribe.vue?vue&type=style&index=0&id=355a6a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355a6a12",
  null
  
)

export default component.exports